import { useState } from "react"
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../../components/ui/tabs"
import { ConnectionCard } from "./ConnectionCard"
import { ConnectionWithProfile } from "../../../services/UserService"

interface ConnectionsListProps {
  connections: ConnectionWithProfile[];
  onUnfollow: (userId: string) => void;
  onFollow: (userId: string) => void;
  followingCount?: number;
  followersCount?: number;
}

export const ConnectionsList = ({ 
  connections, 
  onUnfollow, 
  onFollow, 
  followingCount = 0, 
  followersCount = 0 
}: ConnectionsListProps) => {
  const following = connections.filter(conn => conn.type === 'following')
  const followers = connections.filter(conn => conn.type === 'followers')
  
  // Obtener lista de IDs que ya sigues para verificar en followers
  const followingUserIds = following.map(conn => conn.userId)

  return (
    <div>
      <Tabs defaultValue="following" className="w-full">
        <TabsList className="grid grid-cols-2 w-auto mb-6">
          <TabsTrigger value="following">
            Following ({followingCount})
          </TabsTrigger>
          <TabsTrigger value="followers">
            Followers ({followersCount})
          </TabsTrigger>
        </TabsList>

        <TabsContent value="following">
          <div className="space-y-4">
            {following.map((connection) => (
              <ConnectionCard
                key={connection.id}
                connection={connection}
                onUnfollow={onUnfollow}
                onFollow={onFollow}
                followingUserIds={followingUserIds}
              />
            ))}
            {following.length === 0 && (
              <p className="text-gray-500 text-center py-8">You're not following anyone yet.</p>
            )}
          </div>
        </TabsContent>

        <TabsContent value="followers">
          <div className="space-y-4">
            {followers.map((connection) => (
              <ConnectionCard
                key={connection.id}
                connection={connection}
                onUnfollow={onUnfollow}
                onFollow={onFollow}
                followingUserIds={followingUserIds}
              />
            ))}
            {followers.length === 0 && (
              <p className="text-gray-500 text-center py-8">No followers yet.</p>
            )}
          </div>
        </TabsContent>
      </Tabs>
    </div>
  )
}